export const GOOGLE_REDIRECT_URI = 'https://my.gumtree.com/manage/ads';
export const GOOGLE_CLIENT_ID =
    '67555700125-lvoarr4qau5lkhuks3bn3bl9u3bmmfuf.apps.googleusercontent.com';

export const IOS_SUPPORT_VERSION = '18.1.39';
export const ANDROID_SUPPORT_VERSION = '10.1.43';
